module.exports = require("@bechtel/client-assets/dist/images/welding-required.svg");